// extracted by mini-css-extract-plugin
export default {"loader":"loader--gPeAxGZSfVOXb0qiGeNQ"};